import { useEffect, useState } from 'react';
import { useInterval } from './useInterval';

export const useFiniteInterval = (callback: (...args: any[]) => void, delay: number, iterations: number) => {
  const [count, setCount] = useState<number>(0);

  const {
    start: startInterval,
    stop: stopInterval,
    isOperating,
  } = useInterval(() => {
    setCount(count + 1);
    callback();
  }, delay);

  useEffect(() => {
    if (count > iterations) {
      stop();
    }
  }, [count]);

  function start() {
    startInterval();
  }

  function stop() {
    stopInterval();
  }

  return {
    isOperating,
    start,
    stop,
  };
};

export default useFiniteInterval;
